<div class="app-toast-surface">
  <div class="app-toast-label">{{ message }}</div>
  <div class="app-toast-actions" *ngIf="action">
    <button type="button" class="app-toast-action" (click)="actionClick.emit()">{{ action }}</button>
  </div>
</div>
